export interface TaskTypeOption {
    readonly id: string;
    readonly label: string;
}

/**
 * Human label for a task-type wire value. Hyphens are presentation
 * separators only: the original value remains unchanged on the wire.
 */
export function taskTypeLabel(taskType: string): string {
    return taskType
        .split("-")
        .filter((part) => part.length > 0)
        .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
        .join(" ");
}

export function toTaskTypeOptions(taskTypes: readonly string[]): readonly TaskTypeOption[] {
    return taskTypes.map((id) => ({ id, label: taskTypeLabel(id) }));
}
